import axios from './../../config/axios';

export function getOpenOrdres() {
    return axios().get(`/purchase/dashboard/open-orders`);
}

export function getOutstandingPayment(params) {
    return axios().get(`purchase/dashboard/outstanding-payments`, {
        params: {
            dateFrom : params.currentMonth,
            dateTo: params.perviousMonth
        }
    });
}

export function getTotalPurchasing(params) {
    return axios().get(`purchase/dashboard/total-purchasing`, {
        params: {
            dateFrom : params.currentMonth,
            dateTo: params.perviousMonth
        }
    });
}

export function getBuyingByMonth() {
    return axios().get(`/purchase/dashboard/buying-by-month`);
}

export function getBuyingByCategoriesMonthly() {
    return axios().get(`/purchase/dashboard/buying-categories-monthly`);
}